export const download ={
  // 单个下载各类型文件
  downloadFile(row) {
    // console.log(row);
    this.downloadBatch(row.url, (obj) => {
      let a = document.createElement('a')
      let url = URL.createObjectURL(obj)
      a.href = url
      a.download = row.filename
      a.click()
    })
  },
  // 发送请求
  downloadBatch(file, callback) {
    let request = new XMLHttpRequest()
    request.responseType = 'blob'
    request.open('GET', file)
    request.addEventListener('load', function () {
      callback(request.response)
    })
    request.send()
  },
  // 批量下载
  downloadAll(fileList) {
    for (let i = 0; i < fileList.length; i++) {
      // 调用单个下载方法
      this.downloadFile(fileList[i])
    }
  }
}